import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CommonState } from './common.reducer';
import { EnumMediaEntities } from '../../../api/models';

export const selectCommonState = createFeatureSelector<CommonState>('common');

export const commonSelectors = {
  countries: createSelector(selectCommonState, (state) => state.countries),
  mediaTypes: (entity: EnumMediaEntities) =>
    createSelector(selectCommonState, (state) => state.mediaTypes.find((x) => x.type === entity)),
};
